module.exports = __webpack_public_path__ + "img/cattunnel43.d6eea7ae.jpg";